import { useEffect, useState } from "react";
import { api } from "./api";
import { AgentCategory } from "../types";

// File-based common categories (skills counted separately). Mirrors the set
// served from system/common/agents/<category>/.
const FILE_CATS: readonly AgentCategory[] = [
  AgentCategory.Guides,
  AgentCategory.Loop,
  AgentCategory.Memory,
  AgentCategory.Scripts,
  AgentCategory.Standards,
];

// Total shared-baseline items (skills + common config files) for the Common
// nav badge. `undefined` until the fetch resolves.
export function useCommonCount(): number | undefined {
  const [count, setCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [skills, fileCounts] = await Promise.all([
        api.getSkills().catch(() => []),
        Promise.all(
          FILE_CATS.map((c) =>
            api.getCommonFiles(c).then((r) => r.files.filter((f) => !/^readme\.md$/i.test(f.path)).length).catch(() => 0),
          ),
        ),
      ]);
      if (cancelled) return;
      setCount(skills.length + fileCounts.reduce((a, b) => a + b, 0));
    })();
    return () => { cancelled = true; };
  }, []);

  return count;
}
